import { render, staticRenderFns } from "./BlackPlaceOrderSuccess.vue?vue&type=template&id=672bf5b0&scoped=true&"
import script from "./BlackPlaceOrderSuccess.vue?vue&type=script&lang=js&"
export * from "./BlackPlaceOrderSuccess.vue?vue&type=script&lang=js&"
import style0 from "./BlackPlaceOrderSuccess.vue?vue&type=style&index=0&id=672bf5b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672bf5b0",
  null
  
)

export default component.exports